import classnames from 'classnames'
import { Component } from 'preact'
import { z } from 'zod'
import Phrase from '../../libs/translationsUtils/phrase'
import Icon from '../assets'
import LazyLoader from '@insided/shared/uikit/LazyImage'
import TrackingLink from '../link/tracking-link'

export const widgetName = 'badges'

export const config = z.object({
  title: z.string(),
  amount: z.number().default(5)
})

interface Props {
  title: string
  badges: Array<{
    title: string
    image: string
    username: string
    userUrl: string
  }>
}

export default class BadgesEarned extends Component<Props> {
  render() {
    const props = this.props
    if (!props.badges.length) return null
    return (
      <div className={classnames('box widget widget--badges qa-widget-badges')}>
        <div className='box__content box__pad'>
          {props.title ? <h3 className='widget-title'>{props.title}</h3> : null}
          <TrackingLink
            tag='ul'
            track={{ type: 'Sidebar Widget Clicked', widget: 'badges' }}
            gaEvents={{ eventCategory: 'Homepage', eventAction: 'Widget Clicked', eventLabel: { Type: 'Badges' } }}
            className={classnames('list list--badges unpad--sidebar qa-badges-earned-list')}
          >
            {props.badges.map((badge, index) => {
              return (
                <li key={index}>
                  <div className={classnames('user', 'flag', 'flag--top')}>
                    <div className='flag__image'>
                      <LazyLoader type='img' src={badge.image} title={badge.title} alt={badge.title} />
                    </div>
                    <div className='user_data flag__body'>
                      <a className='link username' href={badge.userUrl}>
                        {badge.username}
                      </a>
                      <span className='text--meta'>
                        <Phrase p='has earned the badge {badgetitle}' count={{ badgetitle: badge.title }} />
                      </span>
                    </div>
                  </div>
                </li>
              )
            })}
          </TrackingLink>
          <a className={classnames('btn--cta', 'btn--show-more', 'link', 'link--underline')} href='/badges'>
            <Phrase p='Show all badges' />
            <Icon customClass='badges-link-text-icon' icon='chevronRight' height={20} width={20} />
          </a>
        </div>
      </div>
    )
  }
}
